import { baseStyles } from '../base-styles';

export function getStyles(accent: string, _position: string): string {
  return baseStyles(accent) + `
    .yd-sidebar-tab {
      position: fixed;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 44px;
      height: 120px;
      background: ${accent};
      color: white;
      border: none;
      border-radius: 8px 0 0 8px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      box-shadow: -2px 0 12px rgba(0,0,0,0.15);
      transition: width 0.2s, box-shadow 0.2s;
      z-index: 1;
      pointer-events: auto;
      padding: 0;
    }
    .yd-sidebar-tab:hover {
      width: 48px;
      box-shadow: -4px 0 20px rgba(0,0,0,0.2);
    }

    .yd-sidebar-tab-text {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.04em;
      writing-mode: vertical-rl;
      text-orientation: mixed;
      transform: rotate(180deg);
      white-space: nowrap;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    @keyframes yd-slide-in {
      from { transform: translateX(100%); }
      to   { transform: translateX(0); }
    }

    .yd-sidebar-panel {
      position: fixed;
      top: 0;
      right: 0;
      height: 100vh;
      width: 380px;
      background: #fff;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      z-index: 1;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      pointer-events: auto;
      box-shadow: -4px 0 32px rgba(0,0,0,0.14);
      animation: yd-slide-in 0.28s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }

    @media (max-width: 480px) {
      .yd-sidebar-panel {
        width: 100%;
      }
      .yd-sidebar-tab {
        display: none;
      }
    }
  `;
}
